import React from 'react';

import InfoComponent from '../../InfoComponent/InfoComponent';

import './Checkbox.scss';

interface Props {
    name: string;
    value: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    checked?: boolean;
    required?: boolean;
    label: string;
    disabled?: boolean;
    infoTitle?: string;
    infoText?: string;
}

const Checkbox: React.FunctionComponent<Props> = (props) => {
    const className = 'fancy-checkbox';
    const inputId = className + '-' + props.name + '-' + props.value;

    return (
        <div className={className}>
            <input
                type="checkbox"
                id={inputId}
                name={props.name}
                value={props.value}
                onChange={props.onChange}
                checked={props.checked}
                required={props.required}
                className={className + '__input'}
                disabled={props.disabled}
            />
            <label htmlFor={inputId}>
                <i className={className + '__i'} />
                <span>
                    {props.label}
                    {props.required ? ' *' : ''}
                </span>
            </label>
            <InfoComponent
                title={props.infoTitle ? props.infoTitle : props.label}
                text={props.infoText}
                nested={true}
            />
        </div>
    );
};

export default Checkbox;
